import { OfferT } from "../../../../domain";
import toast from "react-hot-toast";
import { useRenewOffer } from "../../../services";
import { Button, Form, Input } from "../../../../../../shared/infrastructure";
import React, { useCallback } from "react";
import { number, object } from "yup";

type OfferRenewFormType = {
  rate: number;
};

const OfferRenewFormSchema = object().shape({
  rate: number()
    .typeError("Must be a number")
    .required("Rate is required")
    .positive("Must be positive")
    .max(99999, "Too high"),
});

type OfferStatusUpdateProps = {
  data: OfferT;
  close: () => void;
};

export const RenewOfferConfirmation = ({
  data,
  close,
}: OfferStatusUpdateProps): React.ReactElement => {
  const { mutateAsync: renewOffer, isLoading } = useRenewOffer();

  const handleRenew = useCallback(
    (formData: OfferRenewFormType) => {
      renewOffer({
        offerId: data.approval_id,
        payload: formData,
      })
        .then(() => {
          toast.success("Offer Status Renewed successfully");
          close();
        })
        .catch(() => {
          toast.error("Something happen renewing the offer");
          close();
        });
    },
    [data.approval_id, close, renewOffer]
  );

  return (
    <Form<OfferRenewFormType>
      onSubmit={handleRenew}
      schema={OfferRenewFormSchema}
      className="grid gap-[20px]"
      mode="onChange"
    >
      <section className="grid gap-[4px]">
        <h1 className="text-[20px] font-[700]">Renew Offer</h1>
        <span className="text-[10px] font-[400] text-[#919191]">
          {data.type === "single"
            ? `Order No. ${data.order_number}`
            : "Dedicated"}
        </span>
      </section>
      <section className="grid grid-flow-col justify-start gap-[8px] text-[14px]">
        <span>Please set the rate</span>
        <section className="grid grid-flow-col content-start gap-[4px]">
          <span className="text-[12px] font-[500] text-[#919191]">$</span>
          <Input
            name="rate"
            placeholder="Rate"
            type="text"
            variant="standard"
            rootInputProps={{
              className: "py-1.5 text-[12px] text-center w-[100px]",
            }}
          />
          <span className="text-[12px] font-[500] text-[#919191]">USD</span>
        </section>
      </section>
      <section className="grid grid-flow-col justify-end gap-[20px]">
        <Button
          appearance="secondary"
          className="w-[100px]"
          type="button"
          onClick={close}
        >
          Cancel
        </Button>
        <Button
          appearance="primary"
          className="w-[100px]"
          type="submit"
          status={isLoading ? "loading" : "default"}
        >
          Renew
        </Button>
      </section>
    </Form>
  );
};
